import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, QueryParameter, ModalService, ConfirmationDialogButtons, NotificationService } from 'yt-ng-framework';
import { TrosakDokument } from './trosak-dokument';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators, FormGroup } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { List } from 'immutable';
import { TrosakDokumentView } from './trosak-dokument-view';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-trosak-dokument-update',
  templateUrl: './trosak-dokument-update.component.html'
})
export class TrosakDokumentUpdateComponent extends BaseUpdateComponent<TrosakDokument> implements OnInit {

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected baseDataService: BaseDataService,
        // protected notificationService: NotificationsService,
        protected toastrService: NotificationService,
        protected translateService: TranslateService,
        protected modalService: ModalService
    ) {
        super(activatedRoute, baseDataService, toastrService, translateService, modalService)
    }

    parametersForPodvrstaDokumentStavka: List<QueryParameter> = List([]);
    PodvrstaDokumentStavkaIDParameter: QueryParameter = new QueryParameter();

  ngOnInit() {
    super.ngOnInit();
        this.addValidatorToFc('Broj', Validators.required, 'required', 'TROSAKDOKUMENT.BROJDOKUMENTA.VALIDATION.REQUIRED');
        this.addValidatorToFc('PodVrstaDokumentaStavkaID', Validators.required, 'required', 'TROSAKDOKUMENT.PODVRSTADOKUMENTASTAVKA.VALIDATION.REQUIRED');
        this.addValidatorToFc('Datum', Validators.required, 'required', 'TROSAKDOKUMENT.DATUM.VALIDATION.REQUIRED');
        this.addValidatorToFc('KomitentID', Validators.required, 'required', 'TROSAKDOKUMENT.KOMITENT.VALIDATION.REQUIRED');
        this.addValidatorToFc('BrojFakture', Validators.required, 'required', 'TROSAKDOKUMENT.BROJFAKTURE.VALIDATION.REQUIRED');
        this.addValidatorToFc('BrojFakture', Validators.maxLength(20), 'maxlength', 'TROSAKDOKUMENT.BROJFAKTURE.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('DatumFakture', Validators.required, 'required', 'TROSAKDOKUMENT.DATUMFAKTURE.VALIDATION.REQUIRED');
        this.addValidatorToFc('DatDpo', Validators.required, 'required', 'TROSAKDOKUMENT.DATDPO.VALIDATION.REQUIRED');
        this.addValidatorToFc('Model', Validators.maxLength(2), 'maxlength', 'TROSAKDOKUMENT.MODEL.VALIDATION.MAXLENGTH');
        this.addValidatorToFc('PozivBrojOdobrenja', Validators.maxLength(35), 'maxlength', 'TROSAKDOKUMENT.POZIVBROJODOBRENJA.VALIDATION.MAXLENGTH');
        this.baseFormGroup.setValidators(checkDatumePlacanjaIDatumFakture('DatumFakture','DatDpo'));


        this.IDProcessed
            .subscribe((value) => {
                if (value && this.Item.ID == -1) {
                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').enable();
                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
                    this.baseFormGroup.get('Broj').enable();
                    this.baseFormGroup.get('Broj').updateValueAndValidity();
                    this.baseFormGroup.get('Datum').enable();
                    this.baseFormGroup.get('Datum').updateValueAndValidity();
                    let dateNow = new Date();
                    let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
                    this.baseFormGroup.patchValue({ Datum: date });
                    this.baseFormGroup.get('Datum').updateValueAndValidity();
                    this.enableControls();

                    this.parametersForPodvrstaDokumentStavka = List([]);
                    this.PodvrstaDokumentStavkaIDParameter.Name = "PodvrstaDokumentStavkaID";
                    this.PodvrstaDokumentStavkaIDParameter.Value = this.PodvrstaDokumentaItems.get(0)['ID'];
                    this.parametersForPodvrstaDokumentStavka = this.parametersForPodvrstaDokumentStavka.push(this.PodvrstaDokumentStavkaIDParameter);
                }
                else{
                    this.disableControls();              }
            })
        
            // this.ItemSaved
            // .subscribe((data: TrosakDokumentView) => {
            //     if (data)
            //         this.Item.BrojDokumenta = data.BrojDokumenta;

            // })

            this.ItemSaved
            .subscribe((data: TrosakDokumentView) => {
                this.disableControls();
                this.baseDataService.GetByID(this.modelData.MainList.ModelName, data.ID, this.modelData.MainList.ModelClass)
                    .subscribe((trosakDokument: TrosakDokument) => {
                        if(this.Item['Broj'] != trosakDokument['Broj']){
                            // this.notificationsService.warn('Sačuvani dokument sadrži automatski korigovane podatke');   
                            this.translateService.get(['FAKDOKUMENT.BRDOK.CHANGETEXT', 'FAKDOKUMENT.BRDOK.CHANGEMESSAGE'])
                            .subscribe(translate => {
                                this.modalService.ShowConfirmationDialog(translate['FAKDOKUMENT.BRDOK.CHANGETEXT'],
                                    translate['FAKDOKUMENT.BRDOK.CHANGEMESSAGE'],'warning',ConfirmationDialogButtons.Ok)
                            });
                        }
                        this.Item = trosakDokument;
                        this.baseFormGroup.patchValue(this.Item);
                        this.SavedItem = this.baseFormGroup.getRawValue();  
                    })

            })
  }

    PodvrstaDokumentaItems;
    PodvrstaDokumentaGetItems(items){
        this.PodvrstaDokumentaItems = items;
    }

  disableControls(){
    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').disable();
    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
    this.baseFormGroup.get('Broj').disable();
    this.baseFormGroup.get('Broj').updateValueAndValidity();
    this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
   
    // if (this.router.url == "/fak/racuni"){
    //     this.baseFormGroup.get('Datum').disable();
    //     this.baseFormGroup.get('Datum').updateValueAndValidity();
    // }
}

enableControls(){
    // this.baseFormGroup.get('PodVrstaDokumentaStavkaID').enable();
    // this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
    // this.baseFormGroup.get('Broj').enable();
    // this.baseFormGroup.get('Broj').updateValueAndValidity();
    this.baseFormGroup.enable();
    this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);

}

  onPodVrstaSelect() {
    this.getBrojDokumenta();
}

getBrojDokumenta() {
    let podvrstaid = this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value;
    let datum = this.baseFormGroup.get('Datum').value;
    let _this = this;
    if (this.Item.ID == -1 && podvrstaid && datum)
        this.baseDataService.GetData('TrosakDokument', 'KreirajBrojDokumenta', { 'PodVrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
            .subscribe(data => {
                if (_this.baseFormGroup.get('Datum').value){
                    this.baseFormGroup.patchValue({ Broj: data });
                    this.baseFormGroup.get('Broj').updateValueAndValidity();
                }
            })

}

editMode: boolean = false;
    AddDocument() { }
    //Print(ID1) { }
    item: any;
    PrintKnj(item1) { }
    SaveMaster(qq) { }
    onDatumChange(value) {
        if (value != null) {
            //let datum: QueryParameter = new QueryParameter();
            //datum.Name = 'Datum';
            //datum.Value = value;
            let parameterList: List<QueryParameter> = List([new QueryParameter('Datum', value)]);
            //parameterList = parameterList.push(datum);
            this.TransferParameters = this.TransferParameters.set(0, parameterList);
            this.getBrojDokumenta();
        }
    }
    onRestoreClick(): void {
      this.Reset(true).subscribe((result) => {
        if (result) {
          // console.log('Restore successfully executed');
        } else {
          // console.log('Restore was cancelled by the user');
        }
      });
    }
    }
// }

function checkDatumePlacanjaIDatumFakture(datumFaktureIDKey: string, datDpoIDKey: string){
    return (group: FormGroup): {[key : string]: any} =>{
        let datDpo = group.controls[datDpoIDKey].value;
        let _datDpo : Date = datDpo != null ? new Date(datDpo["year"], datDpo["month"]-1, datDpo["day"]) : null;
        let datumFakture = group.controls[datumFaktureIDKey].value;
        let _datumFakture : Date = datumFakture != null ? new Date(datumFakture["year"], datumFakture["month"]-1, datumFakture["day"]) : null;
       
        if (_datDpo == null || _datDpo >= _datumFakture)
                return null;
           
            
        if (_datDpo < _datumFakture ){
            return { 
                    checkControlsDpo : {valid : _datDpo && _datDpo < _datumFakture ? false : true, message : 'TROSAKDOKUMENT.DATDPOMANJI.VALIDATION'},
                }; 
            }
        }
    }
